import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import mk from './locales/mk.json'
import en from './locales/en.json'
import sq from './locales/sq.json'
import tr from './locales/tr.json'

// i18n from day 1 (plan §11): no UI string is ever written inline in a component.
// English is the default everywhere; MK, SQ and TR are offered once, from what the browser says,
// and remembered when chosen (see LanguageOffer).
export const SUPPORTED_LANGUAGES = ['en', 'mk', 'sq', 'tr']

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      mk: { translation: mk },
      en: { translation: en },
      sq: { translation: sq },
      tr: { translation: tr },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: { escapeValue: false },
    detection: {
      // Only what was chosen. The browser's language is read separately, as a suggestion the
      // visitor is asked about once, rather than silently applied.
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'doseg.lang',
    },
  })

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng
})

export default i18n
